import styled from 'styled-components';

import { AddFilterButton, ButtonContent } from '../../views/listings/ListingsPage/ListingsPage.styles';

export const TriggerButton = styled(AddFilterButton).attrs((props) => ({
  ...props,
  size: 'xs',
  css: {
    ...props.css,
    minWidth: 'unset',
    flexShrink: '0',
  },
}))`
  .nextui-button {
    min-width: unset;
  }
`;

export const SelectionFilterWrapper = styled.div`
  padding: 0;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MobileButtonContent = styled(ButtonContent)`
  padding: 0 0.5rem;
`;
